import { createElement } from 'react';

import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import RadarIcon from '@mui/icons-material/TrackChanges';

import { TechRadarClient } from './api/TechRadarClient';
import { rootRouteRef } from './routes';

const techRadarApi = ApiBlueprint.make({
  name: 'tech-radar',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechRadarClient({ discoveryApi, fetchApi }),
    }),
});

const techRadarPage = PageBlueprint.make({
  name: 'tech-radar',
  params: {
    path: '/tech-radar',
    title: 'Tech Radar',
    icon: createElement(RadarIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { TechRadarPage } = await import('./components/TechRadarPage');
      return createElement(TechRadarPage);
    },
  },
});

export const techRadarPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'tech-radar-frontend',
  extensions: [techRadarApi, techRadarPage],
  routes: {
    root: rootRouteRef,
  },
});
